import { render, staticRenderFns } from "./PluginCardSkeleton.vue?vue&type=template&id=50a58734&scoped=true"
import script from "./PluginCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PluginCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PluginCardSkeleton.vue?vue&type=style&index=0&id=50a58734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a58734",
  null
  
)

export default component.exports